import React, {
  useContext,
  useCallback,
} from 'react';
import { compose } from 'recompose';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

import ChatChannelContext from '../../../../context/ChatChannelContext';
import { CHAT_MESSAGE_REQUEST_STATUS } from '../../../../Model/ChatMessageRequest';

import { CenterLoading } from '../FormScheduleMessage/styles';
import ScheduledMessageItem from './ScheduledMessageItem';

import texts from './texts.json';
import {
  Container,
  InfoText,
} from './styles';

const ScheduledMessagesList = ({ type, deleteOnly }) => {
  const { scheduledMessages, isReady, pendingScheduledMessages } = useContext(ChatChannelContext);

  const isDraftMessagesView = type === CHAT_MESSAGE_REQUEST_STATUS.PENDING;

  const renderContent = useCallback(() => {
    if (isReady) {
      if (!isDraftMessagesView && scheduledMessages.length) {
        return (
          scheduledMessages.map((requestDoc) => (
            <ScheduledMessageItem
              key={requestDoc.id}
              messageRequestDoc={requestDoc}
              isDraftMessagesView={isDraftMessagesView}
            />
          ))
        );
      }
      if (isDraftMessagesView && pendingScheduledMessages.length) {
        return (
          pendingScheduledMessages.map((requestDoc) => (
            <ScheduledMessageItem
              key={requestDoc.id}
              messageRequestDoc={requestDoc}
              isDraftMessagesView={isDraftMessagesView}
              deleteOnly={deleteOnly}
            />
          ))
        );
      }
      return (
        <InfoText>{isDraftMessagesView ? texts.noDraftMessages : texts.noMessages}</InfoText>
      );
    }
    return (
      <CenterLoading>
        <CircularProgress name="crescent" />
      </CenterLoading>
    );
  }, [
    isReady,
    scheduledMessages,
    isDraftMessagesView,
    pendingScheduledMessages,
    deleteOnly,
  ]);

  return (
    <Container>
      {renderContent()}
    </Container>
  );
};

ScheduledMessagesList.propTypes = {
  type: PropTypes.string,
  deleteOnly: PropTypes.bool,
};

ScheduledMessagesList.defaultProps = {
  type: 'scheduled',
  deleteOnly: false,
};

export default compose(
  observer,
)(ScheduledMessagesList);
